import './browser-comp.css';

import * as React from 'react';

interface IBrowserCompProps {
  manualUrl: string;
  token: string;
  email: string;
  iframeKey: number;
}

const baseUrl = 'https://betting-books.stevedavo.com/';

export const BrowserComp: React.SFC<IBrowserCompProps> = props => (
  <div className="book-frame">
    <iframe
      key={props.iframeKey}
      className="browser-comp"
      title="Book"
      src={baseUrl + props.manualUrl + '?email=' + props.email + '&authToken=' + props.token}
    />
  </div>
);
